import { gql } from "@apollo/client";

export interface CreditReceivedListItem {
  payment_id: string;
  payment_date: string | Date;
  payment_method?: string | null;
  payment_amount: number;
  b4_payment_amount?: number | null;
  is_increasement: boolean;
  payment_info?: string | null;
  payment_note?: string | null;
  order_id: string;
  invoice_id: string;
  order_created_at: string | Date;
  member_id: string;
  clinic_member_id: string;
  member_name: string;
  member_phone: string;
  member_code?: string | null;
  is_phone_verified?: boolean | null;
  user_id: string;
  user_name: string;
}

export interface CreditReceivedListResponse {
  totalCount: number;
  data: CreditReceivedListItem[];
}

export const get_credit_received_list = gql`
  query GetCreditReceivedList(
    $clinic_id: String!
    $start_date: DateTime!
    $end_date: DateTime!
    $search: String
    $skip: Int
    $take: Int
  ) {
    getCreditReceivedList(
      clinic_id: $clinic_id
      start_date: $start_date
      end_date: $end_date
      search: $search
      skip: $skip
      take: $take
    ) {
      totalCount
      data {
        payment_id
        payment_date
        payment_method
        payment_amount
        b4_payment_amount
        is_increasement
        payment_info
        payment_note
        order_id
        invoice_id
        order_created_at
        member_id
        clinic_member_id
        member_name
        member_phone
        member_code
        is_phone_verified
        user_id
        user_name
      }
    }
  }
`;

export const get_credit_received_list_count = gql`
  query GetCreditReceivedListCount(
    $clinic_id: String!
    $start_date: DateTime!
    $end_date: DateTime!
    $search: String
  ) {
    getCreditReceivedListCount(
      clinic_id: $clinic_id
      start_date: $start_date
      end_date: $end_date
      search: $search
    )
  }
`;

export const getCreditReceivedListVar = (data: {
  clinic_id: string;
  start_date: Date;
  end_date: Date;
  search?: string;
  skip?: number;
  take?: number;
}) => {
  const variables: any = {
    clinic_id: data.clinic_id,
    start_date: data.start_date,
    end_date: data.end_date,
  };

  if (data.search && data.search.trim() !== "") {
    variables.search = data.search.trim();
  }

  if (data.skip !== undefined) {
    variables.skip = data.skip;
  }

  if (data.take !== undefined) {
    variables.take = data.take;
  }

  return variables;
};
